import { Methods, RestClient } from 'o2o_layout/lib/common/rest';
import { BIGDATA_CONSTANT } from '../../../common/constant';
import { TResponseGetCsrfToken } from './type';

const GetCsrfToken = (): Promise<TResponseGetCsrfToken> => {
  let url = BIGDATA_CONSTANT.url.api + 'security/csrf';
  let restClient = new RestClient(Methods.GET, url);

  return new Promise((resolve, reject) => {
    restClient.execute({}, {}).then(
      (response: any) => {
        const data: TResponseGetCsrfToken = response.data;
        resolve(data);
      },
      (error: any) => {
        reject(error);
      }
    );
  });
};

export default GetCsrfToken;
